<template>
    <div class="barracor">
      <p class="text-center bronze">Lucchese Computação e Estatística Ltda. &copy; 2021</p>
  
      <div class="detalhe_barra bronze ">O site nf.poa.br pertence à Lucchese Computação e Estatística, desenvolvedora dos sistemas Pergamin, com a finalidade de divulgação a acesso ao Portal do seu sistema Pergamin nfpoa, não tendo nenhum vínculo com a Prefeitura de Porto Alegre. Se você deseja acessar a página sobre Notas Fiscais de Serviço Eletrônicas da Prefeitura de Porto Alegre, clique <a class="bronze" href="https://prefeitura.poa.br/carta-de-servicos/nota-fiscal-de-servicos-eletronica-nfs-e">aqui</a>.</div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.barracor{
    background-color: rgb(228, 230, 114)
}
.detalhe_barra{
    padding-left: 2vh;
    padding-right: 2vh;
    font-size: 0.7em;
}
</style>